export default __webpack_public_path__ + "static/921-f94672a62b5063eecf90dfc4e56e797e.gif";